module.exports = __webpack_public_path__ + "static/media/jetpure-3.391a74b4.jpg";